/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanMatch, Route, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { concatMap, filter, take } from 'rxjs/operators';
import { LoggerService } from '../../../modules/shared/services/logger.service';
import { AuthService } from '../../security/services/auth.service';
import { AuthenticatedGuard } from './authenticated.guard';

/**
 * Apply this guard only to resources that are restricted to Admin users
 */
@Injectable()
export class AdminAreaGuard implements CanMatch {

    constructor(
        private logger: LoggerService,
        private authenticatedGuard: AuthenticatedGuard,
        private auth: AuthService
    ) {}

    canMatch(route: Route): Observable<boolean> {
        return this.authenticatedGuard.canLoad(route).pipe(
            filter((b) => b),
            concatMap(() => this.auth.isAdmin$()),
            take(1)
        );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authenticatedGuard.canActivate(route, state).pipe(
            filter((b) => b),
            concatMap(() => this.auth.isAdmin$()),
            take(1)
        );
    }
}
